<template>
  <div class="h-full relative">
    <div
      v-if="isVisible"
      class="absolute h-full w-full flex flex-wrap top-0 left-0 overflow-hidden z-40"
    >
      <div class="w-1/2 shadow-lg" :style="{ backgroundColor: bgColor }">
        <div class="flex justify-between px-12 mt-4">
          <RandomText class="text-6xl"></RandomText>
          <div
            @click="infoShow"
            class="flex justify-end cursor-pointer creu-in"
          >
            <Icon icon="iwwa:close" width="55px" weight="light" />
          </div>
        </div>

        <fidelio-process
          :process="process"
          :processInfo="processInfo"
        ></fidelio-process>
      </div>
      <div class="w-1/2 opacity-60" :style="{ backgroundColor: bgColor }">
        <div
          class="w-full h-full opacity-20"
          :style="{ backgroundColor: bgColor }"
        ></div>
      </div>
    </div>
    <div class="flex flex-col h-full justify-between">
      <div class="flex justify-between">
        <div class="flex z-50 items-end p-4">
          <RandomText class="text-3xl">Wildtech</RandomText>
          <RandomText class="text-xl text-gray-400 pl-1"
            >Web developer</RandomText
          >
        </div>
      </div>
      <div>
        <RandomText class="cursor-pointer text-3xl p-5" @click="processShow"
          >Process</RandomText
        >
      </div>
    </div>

    <slider-projects :slides="slides" />
  </div>
</template>

<script>
import SliderProjects from "@/components/SliderProjects.vue";
import FidelioProcess from "@/components/FidelioProcess.vue";
import RandomText from "@/components/RandomText.vue";

export default {
  name: "App",
  components: {
    SliderProjects,
    FidelioProcess,
    RandomText,
  },
  props: {
    bgColor: {
      type: String,
      required: true,
      default: "rgb(255, 255, 255)",
    },
  },
  data() {
    return {
      isVisible: false,
      slides: [
        {
          type: "text",
          content:
            "WildTech és un projecte de recerca i disseny que té com a objectiu explorar com la tecnologia futura podria donar suport a interaccions profundament alegres, afectuoses i divertides entre els éssers humans i la naturalesa. El professor de la Universitat ERAM, Ferran Altarriba, és el creador d'aquest projecte i, amb l'Ester Montero, som co-creadores d'aquest. En particular, l’Ester s'ha encarregat del UX/UI i les il·lustracions incorporades en la web, mentre que jo m'he ocupat del desenvolupament d'aquesta. La pàgina web reflecteix una part de la recerca que se centra en el Camino de Santiago, en el qual Ferran Altarriba recopila informació sobre com es podrien introduir interaccions en aquest recorregut durant un mes.",
        },
        //{
        //type: "video",
        //content: "/img/wildtech/wildtech.mov",
        //},
        {
          type: "image",
          content: "/img/wildtech/wildtech1.png",
        },
        {
          type: "image",
          content: "/img/wildtech/wildtech2.png",
        },
        {
          type: "image",
          content: "/img/wildtech/wildtech4.png",
        },
        {
          type: "image",
          content: "/img/wildtech/wildtech5.png",
        },
        {
          type: "image",
          content: "/img/wildtech/wildtech6.png",
        },
        {
          type: "image",
          content: "/img/wildtech/wildtech7.png",
        },
      ],
      process: [
        {
          text: "La pàgina web compta amb dues formes diferents de navegació. D'una banda, la navegació guiada et permet descobrir la informació de la pàgina web mentre acompanyes al personatge en el seu Camino de Santiago. D'altra banda, la navegació lliure et permet explorar tota la informació segons les teves preferències, ja sigui per tipus d'informació o per dies específics. A més, pots guardar la informació que et resulti interessant.",
        },
        {
          text: "El desenvolupament de la pàgina web es va dur a terme amb HTML, CSS i JS, i es va utilitzar Vue.js per a la seva creació. La pàgina d'experiència es va construir a partir d'un canvas de JS. Atès que la pàgina requereix d'una gran quantitat d'informació, es va pujar tot a una API que es connecta amb la web.",
        },
      ],
      processInfo: [
        {
          title: "Client:",
          subtitle: "Museum of Ethnography Neuchâtel (MEN)",
        },
        {
          title: "Scenography:",
          subtitle: "Anna Jones, Elfyn Round, Raphaël von Allmen",
        },
        {
          title: "Graphics:",
          subtitle: "Graziella Paiano",
        },
        {
          title: "Light:",
          subtitle: "Lumière Électrique",
        },
        {
          title: "Photography:",
          subtitle: "Prune Simon-Vermot",
        },
      ],
    };
  },
  methods: {
    processShow() {
      this.isVisible = !this.isVisible;
    },
    infoShow() {
      this.isVisible = !this.isVisible;
    },
  },
};
</script>

<style>
.creu-in {
  animation: fadeInOut 5s ease-in-out infinite;
}

@keyframes fadeInOut {
  0% {
    transform: translateY(0) scale(0.7);
    opacity: 100%;
  }
  50% {
    transform: translateY(90vh) scale(0.2);
    opacity: 0%;
  }
  100% {
    transform: translateY(0) scale(0.7);
    opacity: 100%;
  }
}
</style>

